export const serverUrl = import.meta.env.VITE_SERVER_URL;
export const gatewayUrl = import.meta.env.VITE_HOST_GATEWAY_API;

/** Gmail push webhook URL for brokers to register in Google Cloud (override per env). */
export const gmailPushWebhookUrl =
  import.meta.env.VITE_GMAIL_PUSH_WEBHOOK_URL ??
  'https://api-staging.aliebrahimi.me/api/common/communication/v1.0/gmail/push/';
